export const BreakPoints = {
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1200px",
};
